import styled from '@emotion/styled/macro';
import { Variables } from '../base';

export const TablesGroup = styled.div`
    width: 100%;
    display: flex;
    > div {
        width: 50%;
        &:not(:first-of-type) {
            margin-left: 40px;
        }
    }
`;

export const ScrollableCodeContainer = styled.div`
    max-height: 400px;
    overflow: auto;
    border: 1px solid ${Variables.Colors.nx24};
    border-radius: ${Variables.Rounded.small};
    padding: 8px;
    background-color: ${Variables.Colors.nx4};
    width: 100%;
    box-sizing: border-box;
    
    textarea {
        overflow: hidden !important;
        max-height: none !important;
        height: auto !important;
    }
`;

